import RealestateForm from './RealestateForm.vue';

export default RealestateForm;
